export const TRACEABILITY_ITEMS_PER_PAGE = 20

export function normalizePaginationTotal(total) {
    const normalized = Number(total)
    return Number.isFinite(normalized) && normalized >= 0 ? Math.floor(normalized) : 0
}

export function normalizePaginationPage(page) {
    const normalized = Number(page)
    return Number.isInteger(normalized) && normalized > 0 ? normalized : 1
}

export function normalizeItemsPerPage(itemsPerPage, fallback = TRACEABILITY_ITEMS_PER_PAGE) {
    const normalized = Number(itemsPerPage)
    return Number.isInteger(normalized) && normalized > 0 ? normalized : fallback
}

export function getPaginationTotalPages(total, itemsPerPage = TRACEABILITY_ITEMS_PER_PAGE) {
    const normalizedItemsPerPage = normalizeItemsPerPage(itemsPerPage)
    return Math.max(1, Math.ceil(normalizePaginationTotal(total) / normalizedItemsPerPage))
}

export function getVisiblePageNumbers(currentPage, totalPages, maxVisiblePages = 5) {
    const normalizedTotalPages = Math.max(1, normalizePaginationPage(totalPages))
    const normalizedCurrentPage = Math.min(normalizePaginationPage(currentPage), normalizedTotalPages)
    const normalizedMaxVisiblePages = normalizeItemsPerPage(maxVisiblePages, 5)
    const visibleCount = Math.min(normalizedMaxVisiblePages, normalizedTotalPages)
    const pagesBeforeCurrent = Math.floor(visibleCount / 2)
    let firstPage = Math.max(1, normalizedCurrentPage - pagesBeforeCurrent)

    firstPage = Math.min(firstPage, normalizedTotalPages - visibleCount + 1)

    return Array.from({ length: visibleCount }, (value, index) => firstPage + index)
}

export function resolvePaginatedTotal(incomingTotal, previousTotal, requestedPage) {
    const normalizedIncomingTotal = Number(incomingTotal)
    const normalizedRequestedPage = normalizePaginationPage(requestedPage)

    if (normalizedRequestedPage > 1 && normalizedIncomingTotal === -1) {
        return normalizePaginationTotal(previousTotal)
    }

    return normalizePaginationTotal(incomingTotal)
}
